<template>
  <vx-card class="vx-card_full-height">
    <div class="flex flex-col flex-1">
      <div class="vx-row items-center justify-between md:flex-no-wrap flex-wrap flex-shrink-0">
        <div class="vx-col w-auto flex items-center flex-wrap">
          <h4 class="whitespace-no-wrap">Список счетов</h4>
        </div>

        <AccountsFilter :on-change="this.onChangeFilter" />

        <div :class="$style.actions" class="vx-col w-auto md:ml-auto flex items-center md:flex-no-wrap flex-wrap">
          <vs-button
            class="mr-2 mb-2"
            type="border"
            :to="{name: 'uc_b_apartments_groups'}"
            icon-pack="feather"
            icon="icon-layout"
          >
            Проектные помещения
          </vs-button>
          <vs-button
            class="mr-2 mb-2" @click="exportTable()" iconPack="feather" icon="icon-download" type="border"
            title="Экспортировать в CSV"
          />
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-2">
            <vs-button radius icon="icon-settings" icon-pack="feather" />
            <vs-dropdown-menu style="width: 215px;">
              <div class="px-5 py-2" v-for="(filter,index) in columnsFilter" :key="`filter${index}`">
                <vs-checkbox v-model="columnsFilter[index]">{{ findColumnByField(index) }}</vs-checkbox>
              </div>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </div>
      <div class="flex flex-col flex-1 pt-6 accounts__table">
        <grid-infinite-scroll
          ref="table"
          :columns="columns"
          :getData="getData"
          :maxConcurrentDatasourceRequests="4"
          :pageSize="perPage"
          :rowHeight="50"
          :pinnedRowsGetters="pinnedRowsGetters"
          :getPinnedRows="getPinnedRows"
          :filterable="false"
          :sortable="false"
          @updateVisibleColumns="updateShownColumns"
          :shownColumns="columnsFilter"
          noRowsText="Помещения не найдены"
        />
      </div>
    </div>
  </vx-card>
</template>

<script>
import AccountNumberRenderer from "@/components/employee/accounts/AccountNumberRenderer";
import TypeRenderer          from "@/components/employee/accounts/TypeRenderer";
import formatDate            from "@/client/helpers/formatDate";
import AccountsFilter        from "@/components/employee/accounts/AccountsFilter";
import stringify             from "qs/lib/stringify";
import parseJSON             from "@/utils/parseJSON";

export default {
  name:       "Accounts",
  components: { AccountsFilter },
  data() {
    const columns = [
      {
        headerName:            'Счет',
        headerClass:           this.$style.left,
        field:                 'account_number',
        minWidth:              180,
        sortable:              true,
        filter:                true,
        pinned:                'left',
        cellRendererFramework: AccountNumberRenderer,
        cellRendererParams:    ( { data } ) => Object.assign({}, data, { withIcons: true }),
      },
      {
        headerName:            'Тип',
        field:                 'type_apart',
        minWidth:              45,
        width:                 45,
        pinned:                'left',
        cellRendererFramework: TypeRenderer,
        // cellRendererParams:    ( { data } ) => ({ apartment: data }),
      },
      {
        headerName:  'Помещение',
        headerClass: this.$style.left,
        cellClass:   this.$style.left,
        field:       'number',
        minWidth:    120,
        width:       120,
        filter:      true,
        sortable:    true,
        pinned:      'left',
        valueGetter: ( { data } ) => {
          return data.number;
        },
        // cellRendererFramework: NumberRenderer,
        // cellRendererParams:    ( { data } ) => ({ apartment: data }),
      },
      {
        headerName:  'ФИО',
        field:       'users.name',
        headerClass: this.$style.left,
        cellClass:   this.$style.left,
        minWidth:    320,
        filter:      true,
        sortable:    false,
        valueGetter: ( { data } ) => data.b_owner,
      },
      {
        headerName:   'Сальдо начальное',
        key:          'actions',
        field:        'start_sal',
        headerClass:  this.$style.right,
        cellClass:    this.$style.right,
        minWidth:     145,
        valueGetter:  ( { data, forExport } ) => {
          let sum = this.$options.filters.numberWithSpaces(data.start_sal, undefined, true);
          let fine = this.$options.filters.numberWithSpaces(data.fines_st_sal, undefined, true);

          if (forExport) {
            return `${sum} (пени: ${fine})`;
          }

          return {
            sum:        sum,
            fine:       fine,
            fineNumber: data.fines_st_sal,
          };
        },
        cellRenderer: ( { value } ) => {
          return `<div title="${value.sum} (пени: ${value.fine})">${value.sum}<div class="${this.$style.fine} ${+value.fineNumber && this.$style.fineActive}">(пени: ${value.fine})</div></div>`;
        },
      },
      {
        headerName:   'Начислено',
        field:        'charged',
        minWidth:     145,
        headerClass:  this.$style.right,
        cellClass:    this.$style.right,
        valueGetter:  ( { data, forExport } ) => {
          let sum = this.$options.filters.numberWithSpaces(data.charged, undefined, true);
          let fine = this.$options.filters.numberWithSpaces(data.fines_charged, undefined, true);

          if (forExport) {
            return `${sum} (пени: ${fine})`;
          }

          return {
            sum:        sum,
            fine:       fine,
            fineNumber: data.fines_charged,
          };
        },
        cellRenderer: ( { value } ) => {
          return `<div title="${value.sum} (пени: ${value.fine})">${value.sum}<div class="${this.$style.fine} ${+value.fineNumber && this.$style.fineActive}">(пени: ${value.fine})</div></div>`;
        },
      },
      {
        headerName:  'Оплачено',
        field:       'payed',
        headerClass: this.$style.right,
        cellClass:   this.$style.right,
        minWidth:    145,
        filter:      false,
        valueGetter: ( { data } ) => {
          return this.$options.filters.numberWithSpaces(data.payed, undefined, true);
        },
      },
      {
        headerName:  'Сальдо конечное',
        field:       'end_sal',
        headerClass: this.$style.right,
        cellClass:   this.$style.right,
        minWidth:    145,
        valueGetter: ( { data } ) => {
          return this.$options.filters.numberWithSpaces(data.end_sal, undefined, true);
        },
      },
      {
        headerName:  'Площадь',
        field:       'area_all',
        headerClass: this.$style.right,
        cellClass:   this.$style.right,
        minWidth:    100,
        valueGetter: ( { data } ) => {
          return this.$options.filters.numberWithSpaces(data.area_all);
        },
      },
      {
        headerName:  'ЕЛС',
        field:       'els_identifier',
        headerClass: this.$style.left,
        cellClass:   this.$style.left,
        minWidth:    100,
        // valueGetter: ( { data } ) => {
        //   return this.$options.filters.numberWithSpaces(data.area_all);
        // },
      },
      {
        headerName:  'Идентификатор ЖКУ',
        field:       'zku_identifier',
        headerClass: this.$style.left,
        cellClass:   this.$style.left,
        minWidth:    120,
        // valueGetter: ( { data } ) => {
        //   return this.$options.filters.numberWithSpaces(data.area_all);
        // },
      },
      {
        headerName:  'Этаж',
        field:       'floor',
        headerClass: this.$style.right,
        cellClass:   this.$style.right,
        minWidth:    100,
      },
      {
        headerName:  'Прописано',
        field:       'perm_reg',
        headerClass: this.$style.right,
        cellClass:   this.$style.right,
        minWidth:    120,
      },
      {
        headerName:  'Временных',
        field:       'temp_reg',
        headerClass: this.$style.right,
        cellClass:   this.$style.right,
        minWidth:    120,
      },
      {
        headerName:  'Фактически',
        field:       'fact_liv',
        headerClass: this.$style.right,
        cellClass:   this.$style.right,
        minWidth:    120,
      },
      {
        headerName:  'Дата акта ПП',
        field:       'pass_date',
        headerClass: this.$style.left,
        cellClass:   this.$style.left,
        minWidth:    120,
        valueGetter: ( { data } ) => {
          return data.pass_date ? this.$options.filters.moment(this.$parseDateFromString(data.pass_date)) : null;
        },
      },
      {
        headerName:  'Примечание',
        field:       'comment',
        headerClass: this.$style.left,
        cellClass:   this.$style.left,
        minWidth:    400,
      },
    ];

    return {
      filter:            null,
      perPage:           50,
      wasSidebarOpen:    null,
      pageMounted:       false,
      columns,
      pinnedRowsGetters: {
        account_number: 'Всего',
        number:         ( data ) => data.apart_count,
        start_sal:      ( data ) => {
          return {
            sum:        this.$options.filters.numberWithSpaces(data.start_sal, undefined, true),
            fine:       this.$options.filters.numberWithSpaces(data.fines_st_sal, undefined, true),
            fineNumber: data.fines_st_sal,
          };
        },
        charged:        ( data ) => {
          return {
            sum:        this.$options.filters.numberWithSpaces(data.charged, undefined, true),
            fine:       this.$options.filters.numberWithSpaces(data.fines_charged, undefined, true),
            fineNumber: data.fines_charged,
          };
        },
        end_sal:        ( params ) => {
          return this.$options.filters.numberWithSpaces(params.end_sal, undefined, true);
        },
        payed:          ( data ) => {
          return this.$options.filters.numberWithSpaces(data.payed, undefined, true);
        },
        area_all:       ( data ) => {
          return this.$options.filters.numberWithSpaces(data.area_all);
        },
      },
      columnsFilter:     columns.reduce(( dict, column ) => {
        dict[column.field] = true;
        return dict;
      }, {}),
    };
  },
  computed: {
    selectedHouseId() {
      return this.$store.getters['appUser/selectedHouse'].id;
    },
  },
  methods:  {
    async exportTable() {
      this.$refs.table.exportRows('Список лицевых счетов');
    },

    updateShownColumns( filter ) {
      this.columnsFilter = filter;
      localStorage.setItem("AccountsTableColumns", JSON.stringify(filter));
    },

    findColumnByField( field ) {
      let column = this.columns.find(column => column.field === field);
      return column ? column.headerName : '';
    },

    resetData() {
      this.$refs.table && this.$refs.table.resetData();
    },

    getParams( filters ) {
      const { apartmentsType, month, passDate, showArchive, showShownOnly, withoutDatePass } = this.filter;
      const finalFilters = JSON.parse(filters);
      if (!showArchive) finalFilters.push(['is_archive', 'equals', false]);
      if (apartmentsType !== null) finalFilters.push(['type_apart', 'equals', apartmentsType]);
      if (passDate[0]) finalFilters.push(['pass_date', 'greaterThanOrEqual', formatDate(passDate[0], 'yyyy-MM-dd')]);
      if (passDate[1]) finalFilters.push(['pass_date', 'lessThanOrEqual', formatDate(passDate[1], 'yyyy-MM-dd')]);

      return {
        filters:           finalFilters,
        buildings_id:      this.selectedHouseId,
        month:             this.$options.filters.formatDate(month),
        shown_only:        showShownOnly,
        without_date_pass: withoutDatePass,
        // apartments_type: this.selectedApartmentsType === null ? undefined : this.selectedApartmentsType,
        // with_archive:    this.showArchive,
        // privileges_only: this.showPrivilegesOnly,
      };
    },

    getData( page, filters, orderBy ) {
      return this.$http.get(`/building/${this.selectedHouseId}/apartment`, {
        params:           {
          page:     page,
          per_page: page ? this.perPage : undefined,
          order_by: [orderBy],
          ...this.getParams(filters),
        },
        paramsSerializer: ( params ) => stringify(params),
      }).then(( { data } ) => ({
        response: data,
        total:    data.total,
        data:     data.data,
      }));
    },

    getPinnedRows( filters ) {
      return this.$http.get('finance_info', {
        params:           {
          ...this.getParams(filters),
        },
        paramsSerializer: ( params ) => stringify(params),
      }).then(( { data } ) => [{ ...data, number: data.apart_count }]);
    },

    onChangeFilter( filter ) {
      this.filter = filter;
      this.resetData();
    },
  },
  watch:    {
    selectedHouseId() {
      this.resetData();
    },
  },
  created() {
    const savedColumnsFilter = parseJSON(localStorage.getItem("AccountsTableColumns"));
    if (savedColumnsFilter) {
      for (let key in savedColumnsFilter) {
        if (this.columnsFilter.hasOwnProperty(key)) this.columnsFilter[key] = savedColumnsFilter[key];
      }
    }
  },
  mounted() {
    this.wasSidebarOpen = this.$store.state.reduceButton;
    this.$store.commit('TOGGLE_REDUCE_BUTTON', true);
    this.pageMounted = true;
  },
  beforeDestroy() {
    this.$store.commit('TOGGLE_REDUCE_BUTTON', this.wasSidebarOpen);
  },
};
</script>

<style lang="scss" module>
.actions {
  flex-shrink: 0;
}

.left {
  :global(.ag-table-row-pined_bottom) &:global(.ag-cell-value) > span {
    justify-content: flex-start;
  }

  :global {
    .ag-cell-label-container .ag-header-cell-label,
    .ag-table-cell-value {
      //padding: 0 10px;
      justify-content: flex-start;
      text-align: left;

      .ag-header-cell-text {
        text-align: left;
      }
    }
  }
}

.right {
  :global {
    .ag-cell-label-container .ag-header-cell-label,
    .ag-table-cell-value {
      //padding: 0 10px;
      justify-content: flex-end;
      text-align: right;
      font-size: 1.1em;

      .ag-header-cell-text {
        text-align: right;
      }
    }

  }

  &:global(.ag-cell-value) > span {
    font-family: 'Droid Sans Mono', monospace;
    white-space: nowrap;
    justify-content: flex-end !important;
    //font-weight: bold;
    //-webkit-font-smoothing: antialiased;
  }

}

.fine {
  margin-top: 2px;
  font-size: .8em;
  opacity: .2;
  white-space: nowrap;
}

.fineActive {
  opacity: 1;
  //color: color(danger);
}
</style>
